<template>
  <div v-loading="loading" class="vocabulary-homework">
    <div
      class="md-layout-item md-small-size-100 md-xsmall-size-100"
      style="height: 60px"
      :style="$isMobileDevice ? 'margin-bottom: 40px' : ''"
    >
      <div
        class="md-layout w-100 header"
        style="color: #1cab36; margin: 0px 15px 10px 0px"
      >
        <div class="left-hw-btn">
          <md-button
            @click="goBack"
            class="md-icon-button"
            style="height: 58px; width: 58px; margin-right: 20px"
          >
            <md-icon
              style="
                font-size: 36px !important;
                color: #1cab36;
                line-height: 58px;
              "
              >arrow_back</md-icon
            >
          </md-button>

          <div v-if="homework" class="homework-title">
            {{ homework.name }}
          </div>
        </div>

        <div class="right-hw-btn" v-if="!examVaultId && !$route.params.examVaultId">
          <span
            style="margin-right: 10px"
            v-if="homework"
            class="homework-edit"
            @click="handleUpdateHomework"
          >
            <md-icon>edit</md-icon>
            <span class="label">Cập nhật</span>
          </span>
          <span
            v-if="homework"
            class="homework-edit"
            @click="handlePublishHomework"
          >
            <md-icon>public</md-icon>
            <span class="label">{{
              homework.publish ? 'Huỷ phát hành' : 'Phát hành'
            }}</span>
          </span>
        </div>
      </div>
    </div>

    <div v-if="homework" class="question-layout md-layout">
      <div
        class="md-layout-item md-size-25 md-small-size-100 question-group-list"
        :style="$isMobileDevice ? 'margin-bottom: 24px;' : ''"
      >
        <div class="sidebar-header">
          <span class="sidebar-title"><md-icon style="color: #1cab36; margin-right: 6px;">spellcheck</md-icon> Danh sách từ vựng</span>
          <el-tag size="mini" type="success">{{ vocabularies.length }} từ</el-tag>
        </div>

        <div class="question-groups">
          <div
            v-for="(vocab, index) in vocabularies"
            :key="vocab._id || index"
            class="q-item"
            :class="
              currentVocabulary && vocab._id === currentVocabulary._id
                ? 'q-item-selected'
                : ''
            "
            @click="handleSelectVocabulary(vocab)"
          >
            <div class="q-item-left">
              <span class="vocab-index">#{{ vocab.index || index + 1 }}</span>
              <div class="vocab-info">
                <span class="title">{{ vocab.word || 'Từ mới' }}</span>
                <span v-if="vocab.ipa" class="vocab-ipa">/{{ vocab.ipa }}/</span>
              </div>
            </div>
            <div class="settings">
              <el-tag v-if="vocab.type" size="mini" effect="plain" class="type-tag">{{ vocab.type }}</el-tag>
              <span class="action-btn" @click.stop="handleUpdateVocabulary('update', vocab)">
                <md-icon>edit</md-icon>
              </span>
              <span class="action-btn delete-btn" @click.stop="handleDeleteVocabulary(vocab)">
                <md-icon>delete</md-icon>
              </span>
            </div>
          </div>
        </div>

        <div class="add-question-group-btn">
          <el-button type="primary" size="medium" icon="el-icon-plus" @click="handleUpdateVocabulary('create')">
            Thêm từ mới
          </el-button>
        </div>
      </div>

      <div class="md-layout-item md-size-75 preview-section">
        <div v-if="currentVocabulary" class="question-group-preview">
          <div class="vocab-preview-header">
            <div class="word-main">
              <h2 class="word-title">{{ currentVocabulary.word }}</h2>
              <span v-if="currentVocabulary.ipa" class="word-ipa">/{{ currentVocabulary.ipa }}/</span>
              <el-tag v-if="currentVocabulary.type" size="small" type="success" effect="dark">{{ currentVocabulary.type }}</el-tag>
            </div>
            <div v-if="currentVocabulary.audio" class="audio-player-wrapper">
              <audio controls :src="currentVocabulary.audio" class="custom-audio-player"></audio>
            </div>
          </div>

          <div class="vocab-body-card">
            <div v-if="currentVocabulary.means || currentVocabulary.meaning || currentVocabulary.englishMean" class="meaning-box">
              <div class="box-label"><md-icon>translate</md-icon> Nghĩa từ vựng:</div>
              <div class="box-content" v-if="currentVocabulary.means || currentVocabulary.meaning"><strong>Nghĩa tiếng Việt:</strong> <p v-html="currentVocabulary.means || currentVocabulary.meaning"></p></div>
              <div class="box-content" v-if="currentVocabulary.englishMean" style="margin-top: 4px;"><strong>Nghĩa:</strong> {{ currentVocabulary.englishMean }}</div>
            </div>

            <div v-if="currentVocabulary.image" class="image-preview-card">
              <div class="box-label"><md-icon>image</md-icon> Hình ảnh minh họa:</div>
              <img :src="currentVocabulary.image" class="preview-img" />
            </div>
          </div>

          <div v-if="currentVocabulary.videos && currentVocabulary.videos.length > 0" class="examples-section">
            <h4 class="section-subtitle"><md-icon style="color: #1cab36;">movie</md-icon> Ví dụ & Video minh họa</h4>
            <div v-for="(v, idx) in currentVocabulary.videos" :key="idx" class="example-card">
              <div class="ex-badge">Ví dụ #{{ v.index || idx + 1 }}</div>
              <div class="ex-sentence">{{ v.sentence }}</div>
              <div class="ex-translation" v-if="v.translation">{{ v.translation }}</div>
              <div class="ex-media" v-if="v.audio || v.video">
                <audio v-if="v.audio" controls :src="v.audio" class="small-audio"></audio>
                <el-button v-if="v.video" type="text" icon="el-icon-video-play" @click="window.open(v.video, '_blank')">Xem Video</el-button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <md-icon style="font-size: 48px; color: #ccc;">spellcheck</md-icon>
          <p>Chọn từ vựng bên trái để xem chi tiết hoặc bấm nút Thêm từ mới.</p>
        </div>
      </div>
    </div>

    <md-dialog
      :md-active.sync="vocabDialog.visible"
      :md-fullscreen="false"
      class="question-group-dialog custom-vocab-dialog"
    >
      <md-dialog-title>
        <div class="dialog-header-bar">
          <span class="dialog-title-text"><md-icon style="color: #1cab36;">edit</md-icon> {{ vocabDialog.method === 'create' ? 'Thêm từ vựng mới' : 'Chỉnh sửa từ vựng' }}</span>
          <BaseButton :label="$t('SAVE')" @click="saveVocabulary" />
        </div>
      </md-dialog-title>

      <md-dialog-content>
        <div class="dialog-form-container">
          <el-form label-position="top" size="small">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item label="Thứ tự">
                  <el-input-number v-model="temp.index" :min="1" style="width: 100%"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Từ vựng (Word)">
                  <el-input v-model="temp.word" placeholder="Nhập từ vựng..."></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Loại từ (Type)">
                  <el-select v-model="temp.type" placeholder="Chọn loại từ" style="width: 100%" clearable>
                    <el-option v-for="opt in typeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Phiên âm (IPA)">
                  <el-input v-model="temp.ipa" placeholder="VD: /həˈləʊ/"></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="Nghĩa tiếng Việt (means)">
                  <SimpleTinymce v-model="temp.means" :height="200" />
                </el-form-item>
              </el-col> -->
              <el-col :span="12">
                <el-form-item label="Nghĩa">
                  <el-input v-model="temp.englishMean" placeholder="Nhập nghĩa..."></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="Nghĩa tiếng Việt (means)">
                  <SimpleTinymce v-model="temp.means" :height="200" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <BaseInputQuestionFile
                  label="Hình ảnh minh họa (Image)"
                  accept="image/*"
                  :labelSize="14"
                  :loading.sync="uploadLoading.image"
                  v-model="temp.image"
                  iconClass="image"
                  :storageClass="config.storageClass"

                  @file-selected="(val) => { handleUpload('image', val) }"
                  @clear="clearFile('image')"
                />
              </el-col>
              <el-col :span="8">
                <BaseInputQuestionFile
                  label="Âm thanh phát âm (Audio)"
                  accept="audio/*"
                  :labelSize="14"
                  :loading.sync="uploadLoading.audio"
                  v-model="temp.audio"
                  iconClass="audiotrack"
                  :storageClass="config.storageClass"

                  @file-selected="(val) => { handleUpload('audio', val) }"
                  @clear="clearFile('audio')"
                />
              </el-col>
              <el-col :span="8">
                <BaseInputQuestionFile
                  label="Video phát âm"
                  accept="video/*"
                  :labelSize="14"
                  :loading.sync="uploadLoading.video"
                  v-model="temp.video"
                  iconClass="videocam"
                  :storageClass="config.storageClass"

                  @file-selected="(val) => { handleUpload('video', val) }"
                  @clear="clearFile('video')"
                />
              </el-col>
            </el-row>

            <el-row :gutter="20" style="margin-top: 10px;">
              <el-col :span="12">
                <BaseInputQuestionFile
                  label="Audio giải thích nghĩa"
                  accept="audio/*"
                  :labelSize="14"
                  :loading.sync="uploadLoading.englishMeanAudio"
                  v-model="temp.englishMeanAudio"
                  iconClass="audiotrack"
                  :storageClass="config.storageClass"

                  @file-selected="(val) => { handleUpload('englishMeanAudio', val) }"
                  @clear="clearFile('englishMeanAudio')"
                />
              </el-col>
              <el-col :span="12">
                <BaseInputQuestionFile
                  label="Video giải thích nghĩa"
                  accept="video/*"
                  :labelSize="14"
                  :loading.sync="uploadLoading.englishMeanVideo"
                  v-model="temp.englishMeanVideo"
                  iconClass="videocam"
                  :storageClass="config.storageClass"

                  @file-selected="(val) => { handleUpload('englishMeanVideo', val) }"
                  @clear="clearFile('englishMeanVideo')"
                />
              </el-col>
            </el-row>

            <div class="example-section-editor">
              <div class="editor-header">
                <span class="editor-title"><md-icon style="color: #1cab36;">list</md-icon> Danh sách Video & Ví dụ câu</span>
                <el-button type="success" size="mini" icon="el-icon-plus" @click="addVideoItem">Thêm ví dụ</el-button>
              </div>

              <div v-for="(vItem, vIdx) in temp.videos" :key="vIdx" class="example-item-box">
                <el-button type="danger" circle size="mini" class="remove-ex-btn" icon="el-icon-close" @click="removeVideoItem(vIdx)"></el-button>
                <el-row :gutter="15">
                  <el-col :span="6">
                    <el-form-item label="Thứ tự">
                      <el-input-number v-model="vItem.index" :min="1" style="width: 100%"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="18">
                    <el-form-item label="Câu ví dụ (Sentence)">
                      <el-input v-model="vItem.sentence" placeholder="Nhập câu ví dụ..."></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="Dịch nghĩa (Translation)">
                  <el-input v-model="vItem.translation" placeholder="Nhập dịch nghĩa câu..."></el-input>
                </el-form-item>

                <el-row :gutter="15">
                  <el-col :span="12">
                    <BaseInputQuestionFile
                      label="Video ví dụ"
                      accept="video/*"
                      :labelSize="14"
                      :loading.sync="uploadLoading['video'+vIdx]"
                      v-model="vItem.video"
                      iconClass="videocam"
                      :storageClass="config.storageClass"

                      @file-selected="(val) => { handleUpload('video', val, vIdx) }"
                      @clear="clearFile('video', vIdx)"
                    />
                  </el-col>
                  <el-col :span="12">
                    <BaseInputQuestionFile
                      label="Audio ví dụ"
                      accept="audio/*"
                      :labelSize="14"
                      :loading.sync="uploadLoading['audio'+vIdx]"
                      v-model="vItem.audio"
                      iconClass="audiotrack"
                      :storageClass="config.storageClass"

                      @file-selected="(val) => { handleUpload('audio', val, vIdx) }"
                      @clear="clearFile('audio', vIdx)"
                    />
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-form>
        </div>
      </md-dialog-content>
    </md-dialog>

    <md-dialog
      :md-active.sync="updateHomeworkDialog"
      class="update-homework-dialog"
      @md-clicked-outside="updateHomeworkDialog = false"
    >
      <md-dialog-title>
        <div class="title">
          {{ $t('UPDATE') }}
        </div>
      </md-dialog-title>
      <md-dialog-content v-loading="dialogLoading">
        <div class="input-field">
          <BaseInputText
            :placeholder="$t('NAME')"
            :label="$t('NAME')"
            v-model="homeworkTemp.name"
          />
        </div>
        <div class="input-field">
          <label class="label">{{ $t('HW_VIDEO_SUBJECT') }}</label>
          <BaseInputSelectV2
            v-if="examVaultConfig && examVaultConfig.subjects"
            :options="mappedSubjects"
            :opt-key="'mappedId'"
            :opt-value="`${$i18n.locale}Value`"
            v-model="homeworkTemp.subject"
          />
        </div>
        <div class="input-field">
          <BaseInputSelect
            :multiple="true"
            :options="getStudents()"
            opt-value="fullname"
            :placeholder="$t('ASSIGNEES')"
            :label="$t('ASSIGNEES')"
            v-model="homeworkTemp.assignedEIDs"
            :value="homeworkTemp.assignedEIDs"
            @update="handleChangeAssignStudent"
          />
        </div>
        <div class="input-field">
          <BaseDatePicker
            :placeholder="$t('EXER_ASSIGN_DATE')"
            :label="$t('EXER_ASSIGN_DATE')"
            v-model="homeworkTemp.startAt"
          />
        </div>
        <div class="input-field">
          <BaseDatePicker
            :placeholder="$t('EXER_DEADLINE_DATE')"
            :label="$t('EXER_DEADLINE_DATE')"
            v-model="homeworkTemp.endAt"
          />
        </div>
        <BaseInputText
          :placeholder="$t('EXER_TRY_TIMES')"
          :label="$t('EXER_TRY_TIMES')"
          :labelSize="18"
          :max="100"
          type="number"
          v-model="homeworkTemp.limitSubmit"
        />
        <div class="input-field" style="padding-top: 20px">
          <BaseCheckbox :label="$t('SHOW_ANSWER_KEY')" v-model="homeworkTemp.showAnswerKey" />
        </div>
        <div class="btn-block" style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px;">
          <md-button class="md-raised" @click.prevent="updateHomeworkDialog = false">
            {{ $t('CANCEL') }}
          </md-button>
          <md-button
            class="md-raised md-primary text-white"
            @click.prevent="saveHomeworkSettings"
          >
            {{ $t('UPDATE') }}
          </md-button>
        </div>
      </md-dialog-content>
    </md-dialog>

    <el-dialog
      :visible.sync="examVaultDialog.visible"
      @close="examVaultDialog.visible = false"
      title="Kho học liệu"
      width="85%"
      append-to-body
    >
      <ExamVaultView @selectExam="handleSelectExam" />
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { uploadHomeworkAttachment } from '@/api/content'
import { mapGetters } from 'vuex'
import ExamVaultView from '@/views/ExamVault/components/ExamVaultView.vue'
import examVaultApi from '@/api/exam-vault'
import SimpleTinymce from '@/components/SimpleTinymce'

function generateObjectId() {
  const timestamp = Math.floor(Date.now() / 1000).toString(16).padStart(8, '0')
  const randomHex = Array.from({ length: 16 }, () => Math.floor(Math.random() * 16).toString(16)).join('')
  return timestamp + randomHex
}

export default {
  name: 'ClassVocabularyHomework',
  props: {
    examVaultId: {
      type: String,
      default: null
    },
    initialExam: {
      type: Object,
      default: null
    }
  },
  components: {
    ExamVaultView,
    SimpleTinymce
  },
  data() {
    return {
      classUid: null,
      homeworkUid: null,
      homework: null,
      vocabularies: [],
      currentVocabulary: null,
      loading: false,
      vocabDialog: {
        visible: false,
        method: 'create'
      },
      updateHomeworkDialog: false,
      dialogLoading: false,
      homeworkTemp: {},
      examVaultDialog: {
        visible: false
      },
      typeOptions: [
        { label: 'Danh từ (NOUN)', value: 'NOUN' },
        { label: 'Động từ (VERB)', value: 'VERB' },
        { label: 'Tính từ (ADJECTIVE)', value: 'ADJECTIVE' },
        { label: 'Phó từ (ADVERB)', value: 'ADVERB' },
        { label: 'Giới từ (PREPOSITION)', value: 'PREPOSITION' },
        { label: 'Đại từ (PRONOUN)', value: 'PRONOUN' },
        { label: 'Số từ (NUMERAL)', value: 'NUMERAL' },
        { label: 'Liên từ (CONJUNCTION)', value: 'CONJUNCTION' },
        { label: 'Thán từ (INTERJECTION)', value: 'INTERJECTION' }
      ],
      temp: {
        _id: null,
        index: 1,
        code: '',
        word: '',
        type: '',
        ipa: '',
        means: '',
        meaning: '',
        englishMean: '',
        displayType: 1,
        image: '',
        audio: '',
        video: '',
        englishMeanAudio: '',
        englishMeanVideo: '',
        isTrial: false,
        publish: true,
        subject: '',
        videos: []
      },
      uploadLoading: {
        image: false,
        audio: false
      },
      config: {
        storageClass: 'STANDARD'
      }
    }
  },
  computed: {
    ...mapGetters({
      eClass: 'eClass',
      students: 'students'
    }),
    examVaultConfig() {
      return this.$store.state['exam-vault'].config
    },
    mappedSubjects() {
      if (!this.examVaultConfig || !this.examVaultConfig.subjects) return []
      return this.examVaultConfig.subjects.map(s => ({
        ...s,
        mappedId: this.getMappedSubject(s._id)
      }))
    }
  },
  async created() {
    this.classUid = this.$route.params.classUid
    this.homeworkUid = this.$route.query.homeworkUid
    const targetExamVaultId = this.examVaultId || this.$route.params.examVaultId
    if (targetExamVaultId) {
      await this.fetchExamVaultData(targetExamVaultId)
    } else {
      if (!this.examVaultConfig || !this.examVaultConfig.subjects || this.examVaultConfig.subjects.length === 0) {
        this.$store.dispatch('exam-vault/fetchExamConfig')
      }
      await this.fetchData()
    }
  },
  methods: {
    async handleUpload(key, files, vIdx = null) {
      if (files.length > 0) {
        await this.uploadAttachment(files[0], key, vIdx)
      }
    },
    async uploadAttachment(file, key, vIdx = null) {
      const loadingKey = vIdx !== null ? key + vIdx : key
      if (this.uploadLoading[loadingKey]) {
        this.$notify({
          type: 'warning',
          title: 'Lỗi',
          message: 'Vui lòng đợi tải lên các tập tin trước đó hoàn tất.'
        })
        return
      }

      this.$set(this.uploadLoading, loadingKey, true)
      try {
        const targetId = this.examVaultId || this.$route.params.examVaultId
        let response
        if (targetId) {
          response = await examVaultApi.uploadAttachment({
            file,
            examVaultId: targetId
          })
        } else {
          const classId = this.homework.classId
          response = await uploadHomeworkAttachment({
            file,
            classId: classId
          })
        }
        if (response.data && response.data.key) {
          if (vIdx !== null) {
            this.$set(this.temp.videos[vIdx], key, '/' + response.data.key)
          } else {
            this.$set(this.temp, key, '/' + response.data.key)
          }
        } else {
          this.$message.error('Tải lên thất bại')
        }
      } catch (e) {
        this.$message.error('Lỗi khi tải lên file')
      } finally {
        this.$set(this.uploadLoading, loadingKey, false)
      }
    },
    clearFile(key, vIdx = null) {
      if (vIdx !== null) {
        this.$set(this.temp.videos[vIdx], key, '')
      } else {
        this.$set(this.temp, key, '')
      }
    },
    async fetchExamVaultData(id) {
      this.loading = true
      try {
        let examData = this.initialExam
        if (!examData || !examData._id) {
          const res = await examVaultApi.getExamById(id)
          examData = res.data || res
        }
        this.homework = {
          _id: examData._id,
          name: examData.title,
          title: examData.title,
          subject: examData.subject ? (examData.subject.value || examData.subject) : '',
          ...examData
        }
        const rawVocabs = examData.vocabularies || []
        this.vocabularies = rawVocabs.map((v, i) => ({
          ...v,
          means: v.means || v.meaning || '',
          meaning: v.meaning || v.means || '',
          _id: v._id || v.id || generateObjectId(),
          index: v.index || i + 1
        }))
        if (this.vocabularies.length > 0) {
          this.currentVocabulary = this.vocabularies[0]
        }
      } catch (err) {
        this.$message.error('Lỗi khi tải dữ liệu từ vựng kho học liệu')
      } finally {
        this.loading = false
      }
    },
    async fetchData() {
      this.loading = true
      try {
        if (this.classUid) {
          await this.$store.dispatch('content/getClass', {
            classUid: this.classUid
          })
        }
        const homework = await this.$store.dispatch('content/getHomework', {
          classId: this.classUid,
          homeworkUid: this.homeworkUid
        })
        this.homework = _.cloneDeep(homework)
        const rawVocabs = this.homework.vocabularies || []
        this.vocabularies = rawVocabs.map((v, i) => ({
          ...v,
          means: v.means || v.meaning || '',
          meaning: v.meaning || v.means || '',
          _id: v._id || v.id || generateObjectId(),
          index: v.index || i + 1
        }))
        if (this.vocabularies.length > 0) {
          this.currentVocabulary = this.vocabularies[0]
        }
      } catch (err) {
        this.$message.error('Lỗi khi tải dữ liệu bài tập')
      } finally {
        this.loading = false
      }
    },
    getStudents() {
      return (this.students || [])
        .filter((d) => !_.isNil(d.eID) && d.status === 'approved')
        .map((d) => ({ ...d, _id: d.eID }))
    },
    handleChangeAssignStudent() {
      if (this.homework && this.homework.isLocked && this.homework.assignedEIDs) {
        const currentIds = this.homeworkTemp.assignedEIDs || []
        const originalIds = this.homework.assignedEIDs || []
        const missingIds = originalIds.filter((id) => !currentIds.includes(id))
        if (missingIds.length > 0) {
          this.$set(this.homeworkTemp, 'assignedEIDs', [
            ...currentIds,
            ...missingIds
          ])
          this.$notify({
            type: 'warning',
            title: 'Warning',
            message: 'Không thể bỏ học sinh đã được giao bài tập.'
          })
        }
      }
      this.$set(
        this.homeworkTemp,
        'assignAll',
        this.homeworkTemp.assignedEIDs ? this.homeworkTemp.assignedEIDs.length === this.getStudents().length : false
      )
    },
    getMappedSubject(subjectId) {
      if (!subjectId) return null
      const subjectMap = {
        english: 'en',
        math: 'math',
        vietnamese: 'vi',
        chemistry: 'chem',
        chinese: 'zh',
        vi: 'vi',
        en: 'en'
      }
      if (this.examVaultConfig && this.examVaultConfig.subjects) {
        const found = this.examVaultConfig.subjects.find(s => s._id === subjectId)
        if (found && found.value) {
          const valLower = found.value.toLowerCase()
          return subjectMap[valLower] || valLower.substring(0, 2)
        }
      }
      const idLower = subjectId.toLowerCase()
      return subjectMap[idLower] || idLower.substring(0, 2)
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push({
          path: '/kho-hoc-lieu',
          query: this.$route.query
        })
      }
    },
    handleSelectVocabulary(vocab) {
      this.currentVocabulary = vocab
    },
    handleUpdateVocabulary(method, vocab) {
      this.vocabDialog.method = method
      if (method === 'create') {
        this.temp = {
          _id: generateObjectId(),
          index: this.vocabularies.length + 1,
          subject: this.homework ? this.homework.subject : '',
          code: '',
          word: '',
          type: '',
          ipa: '',
          means: '',
          meaning: '',
          englishMean: '',
          displayType: 1,
          image: '',
          audio: '',
          video: '',
          englishMeanAudio: '',
          englishMeanVideo: '',
          isTrial: false,
          publish: true,
          videos: []
        }
      } else {
        this.temp = _.cloneDeep(vocab)
        this.temp.means = this.temp.means || this.temp.meaning || ''
        this.temp.meaning = this.temp.meaning || this.temp.means || ''
        if (!this.temp._id) {
          this.temp._id = vocab.id || generateObjectId()
        }
      }
      this.vocabDialog.visible = true
    },
    async saveVocabulariesToBackend() {
      try {
        const targetId = this.examVaultId || this.$route.params.examVaultId
        if (targetId) {
          const payload = {
            ...this.homework,
            vocabularies: this.vocabularies
          }
          if (payload.subject && payload.subject._id) payload.subject = payload.subject._id
          if (payload.productType && payload.productType._id) payload.productType = payload.productType._id
          if (payload.categoryIds) {
            payload.categoryIds = payload.categoryIds.map(c => c._id || c)
          }
          await examVaultApi.updateExam(payload)
        } else {
          const payload = {
            ...this.homework,
            classId: this.classUid,
            vocabularies: this.vocabularies
          }
          const updated = await this.$store.dispatch('content/updateVocabularyHomework', payload)
          if (updated) {
            this.homework = _.cloneDeep(updated)
            if (updated.vocabularies && updated.vocabularies.length > 0) {
              this.vocabularies = updated.vocabularies.map((v, i) => ({
                ...v,
                _id: v._id || v.id || (this.vocabularies[i] ? this.vocabularies[i]._id : generateObjectId()),
                index: v.index || i + 1
              }))
            }
          } else {
            this.homework = _.cloneDeep(payload)
          }
        }
      } catch (err) {
        this.$message.error('Lỗi khi tự động lưu từ vựng')
      }
    },

    handleDeleteVocabulary(vocab) {
      this.$confirm('Bạn có chắc chắn muốn xoá từ này?', 'Cảnh báo', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(async () => {
        const targetId = vocab._id || vocab.id || vocab.word
        this.vocabularies = this.vocabularies.filter(v => {
          const vId = v._id || v.id || v.word
          return vId !== targetId
        })
        if (this.currentVocabulary) {
          const curId = this.currentVocabulary._id || this.currentVocabulary.id || this.currentVocabulary.word
          if (curId === targetId) {
            this.currentVocabulary = this.vocabularies.length > 0 ? this.vocabularies[0] : null
          }
        }
        await this.saveVocabulariesToBackend()
        this.$message.success('Đã xoá từ vựng')
      })
    },

    addVideoItem() {
      if (!this.temp.videos) this.$set(this.temp, 'videos', [])
      this.temp.videos.push({
        index: this.temp.videos.length + 1,
        sentence: '',
        translation: '',
        video: '',
        audio: ''
      })
    },
    removeVideoItem(idx) {
      this.temp.videos.splice(idx, 1)
    },
    async saveVocabulary() {
      if (!this.temp.word) {
        this.$message.error('Vui lòng nhập từ vựng')
        return
      }
      if (!this.temp._id) {
        this.temp._id = generateObjectId()
      }
      this.temp.means = this.temp.means || this.temp.meaning || ''
      this.temp.meaning = this.temp.means || this.temp.meaning || ''
      if (this.vocabDialog.method === 'create') {
        this.vocabularies.push(_.cloneDeep(this.temp))
      } else {
        const targetId = this.temp._id
        const idx = this.vocabularies.findIndex(v => (v._id || v.id) === targetId)
        if (idx !== -1) {
          this.$set(this.vocabularies, idx, _.cloneDeep(this.temp))
          if (this.currentVocabulary && (this.currentVocabulary._id || this.currentVocabulary.id) === targetId) {
            this.currentVocabulary = this.vocabularies[idx]
          }
        }
      }
      this.vocabDialog.visible = false
      await this.saveVocabulariesToBackend()
      this.$message.success('Lưu từ vựng thành công')
    },
    handleUpdateHomework() {
      this.homeworkTemp = _.cloneDeep(this.homework)
      this.updateHomeworkDialog = true
    },
    async saveHomeworkSettings() {
      this.dialogLoading = true
      try {
        const targetId = this.examVaultId || this.$route.params.examVaultId
        if (targetId) {
          await examVaultApi.updateExam({
            _id: targetId,
            title: this.homeworkTemp.name,
            subject: this.homeworkTemp.subject
          })
          this.homework.name = this.homeworkTemp.name
          this.homework.title = this.homeworkTemp.name
        } else {
          const payload = {
            ...this.homeworkTemp,
            classId: this.classUid,
            vocabularies: this.vocabularies
          }
          await this.$store.dispatch('content/updateVocabularyHomework', payload)
          this.homework = _.cloneDeep(payload)
        }
        this.updateHomeworkDialog = false
        this.$message.success('Cập nhật thông tin bài tập thành công')
      } catch (err) {
        this.$message.error('Cập nhật thất bại')
      } finally {
        this.dialogLoading = false
      }
    },
    async handlePublishHomework() {
      this.loading = true
      try {
        const payload = {
          ...this.homework,
          classId: this.classUid,
          vocabularies: this.vocabularies,
          publish: !this.homework.publish
        }
        await this.$store.dispatch('content/publishVocabularyHomework', payload)
        this.homework.publish = !this.homework.publish
        this.$message.success('Thao tác thành công')
      } catch (err) {
        this.$message.error('Thao tác thất bại')
      } finally {
        this.loading = false
      }
    },
    handleCloneExamVault() {
      this.examVaultDialog.visible = true
    },
    async handleSelectExam(exam) {
      this.examVaultDialog.visible = false
      if (exam && exam.vocabularies && exam.vocabularies.length > 0) {
        const clonedVocabs = _.cloneDeep(exam.vocabularies).map((v, i) => ({
          ...v,
          _id: v._id || v.id || generateObjectId(),
          index: this.vocabularies.length + i + 1
        }))
        this.vocabularies = [...this.vocabularies, ...clonedVocabs]
        if (!this.currentVocabulary && this.vocabularies.length > 0) {
          this.currentVocabulary = this.vocabularies[0]
        }
        await this.saveVocabulariesToBackend()
        this.$message.success(`Đã lấy ${exam.vocabularies.length} từ vựng từ Kho học liệu`)
      } else {
        this.$message.warning('Kho học liệu này không có dữ liệu từ vựng')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.vocabulary-homework {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 10px 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  .left-hw-btn {
    display: flex;
    align-items: center;
  }
  .homework-title {
    font-size: 20px;
    font-weight: bold;
    color: #2c3e50;
  }
  .right-hw-btn {
    display: flex;
    align-items: center;
    .homework-edit {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-left: 20px;
      color: #606266;
      transition: color 0.2s;
      &:hover {
        color: #1cab36;
      }
      .label {
        margin-left: 5px;
        font-weight: 500;
      }
    }
  }
}
.question-layout {
  margin-top: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  min-height: 550px;
}
.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  .sidebar-title {
    font-weight: bold;
    font-size: 15px;
    color: #2c3e50;
    display: flex;
    align-items: center;
  }
}
.question-group-list {
  border-right: 1px solid #ebeef5;
  padding: 20px;
  .q-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom: 8px;
    border: 1px solid #f0f2f5;
    transition: all 0.2s ease;
    &:hover {
      border-color: #1cab36;
      background: #f6ffed;
    }
    &-selected {
      background: #e8f5e9;
      border-color: #1cab36;
      .title {
        color: #1cab36;
        font-weight: bold;
      }
    }
    .q-item-left {
      display: flex;
      align-items: center;
      gap: 10px;
      .vocab-index {
        font-size: 12px;
        font-weight: 700;
        color: #909399;
        background: #f4f4f5;
        padding: 2px 6px;
        border-radius: 4px;
      }
      .vocab-info {
        display: flex;
        flex-direction: column;
        .title {
          font-size: 14px;
          color: #303133;
        }
        .vocab-ipa {
          font-size: 12px;
          color: #909399;
        }
      }
    }
    .settings {
      display: flex;
      align-items: center;
      gap: 6px;
      .type-tag {
        font-size: 10px;
      }
      .action-btn {
        color: #909399;
        cursor: pointer;
        padding: 2px;
        border-radius: 4px;
        &:hover {
          color: #1cab36;
          background: #e8f5e9;
        }
        &.delete-btn:hover {
          color: #f56c6c;
          background: #fef0f0;
        }
      }
    }
  }
  .add-question-group-btn {
    margin-top: 20px;
    display: flex;
    gap: 10px;
    justify-content: center;
  }
}
.preview-section {
  padding: 24px;
}
.vocab-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 20px;
  .word-main {
    display: flex;
    align-items: baseline;
    gap: 12px;
    .word-title {
      font-size: 28px;
      font-weight: 800;
      color: #1cab36;
      margin: 0;
    }
    .word-ipa {
      font-size: 16px;
      color: #606266;
      font-style: italic;
    }
  }
  .custom-audio-player {
    height: 38px;
  }
}
.vocab-body-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
  .box-label {
    font-size: 14px;
    font-weight: 600;
    color: #606266;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .meaning-box {
    background: #f8f9fa;
    padding: 16px;
    border-radius: 8px;
    border-left: 4px solid #1cab36;
    .box-content {
      font-size: 16px;
      color: #2c3e50;
      font-weight: 500;
    }
  }
  .image-preview-card {
    background: #f8f9fa;
    padding: 16px;
    border-radius: 8px;
    .preview-img {
      max-width: 280px;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }
  }
}
.examples-section {
  .section-subtitle {
    font-size: 16px;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .example-card {
    background: #fdfdfd;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 14px;
    margin-bottom: 12px;
    position: relative;
    .ex-badge {
      font-size: 11px;
      font-weight: 700;
      color: #1cab36;
      background: #e8f5e9;
      display: inline-block;
      padding: 2px 8px;
      border-radius: 4px;
      margin-bottom: 6px;
    }
    .ex-sentence {
      font-size: 15px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 4px;
    }
    .ex-translation {
      font-size: 14px;
      color: #606266;
    }
    .ex-media {
      margin-top: 10px;
      display: flex;
      align-items: center;
      gap: 12px;
      .small-audio {
        height: 28px;
      }
    }
  }
}
.empty-state {
  text-align: center;
  padding: 80px 20px;
  p {
    color: #909399;
    margin-top: 12px;
    font-size: 15px;
  }
}
.custom-vocab-dialog {
  .dialog-header-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .dialog-title-text {
      font-size: 18px;
      font-weight: 700;
      color: #2c3e50;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
  .dialog-form-container {
    padding: 10px 0;
  }
  .example-section-editor {
    margin-top: 24px;
    border-top: 1px solid #ebeef5;
    padding-top: 16px;
    .editor-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      .editor-title {
        font-size: 15px;
        font-weight: 700;
        color: #2c3e50;
        display: flex;
        align-items: center;
        gap: 6px;
      }
    }
    .example-item-box {
      background: #f8f9fa;
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      padding: 16px;
      margin-bottom: 16px;
      position: relative;
      .remove-ex-btn {
        position: absolute;
        right: 10px;
        top: 10px;
      }
    }
  }
}
</style>
